import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import AccessorialExceptionsV1 from 'components/modules/exceptions/AccessorialExceptions';
import AccessorialExceptionsV2 from 'components/modules/exceptions/v2/AccessorialExceptions';
/**
 * Switches between v1 and v2 of the Accessorial Exceptions page.
 *
 * URL overrides take precedence over the LaunchDarkly flag:
 *   - `?version=1` forces v1 (manual override for QA / dev preview)
 *   - `?version=2` forces v2 (manual override for QA / dev preview)
 *
 * Otherwise v2 is shown when the LaunchDarkly flag
 * `enableAccessorialRequestsV2` is on, falling back to v1.
 */
export function AccessorialExceptionsRouter(props) {
    const flags = useFlags();
    const params = new URLSearchParams(window.location.search);
    const versionParam = params.get('version');
    const showV2 = versionParam === '2' ||
        (versionParam !== '1' && Boolean(flags.enableAccessorialRequestsV2));
    const Component = showV2 ? AccessorialExceptionsV2 : AccessorialExceptionsV1;
    return React.createElement(Component, Object.assign({}, props));
}
